// @flow
import React from 'react';
import PropTypes from 'prop-types'
import { pure } from 'recompose';
import styled from 'styled-components';

const propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

const defaultProps = {
  size: '1rem',
  color: 'black'
};

const StyledIcon = styled(({width, height, fill, children, ...rest}) => {
  return <svg {...rest}>{children}</svg>;
})`
  display: inline-block;
  vertical-align: middle;
  ${props => props.width && (`
    width: ${props.width};
  `)}
  ${props => props.height && (`
    height: ${props.height};
  `)}
  ${props => props.fill && (`
     fill: ${props.fill};
  `)}
`;

StyledIcon.defaultProps = {
  fill: 'currentColor'
};


const Icon = (props) => {
  return (
    <StyledIcon
        className={props.className}
        width={props.width}
        height={props.height}
        fill={props.fill}
        xmlns="http://www.w3.org/2000/svg" version="1.1"
      >
        <use xlinkHref={`${props.icon}`} />
    </StyledIcon>
  );
};

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

export default pure(Icon);



// WEBPACK FOOTER //
// ./src/modules/common/components/icon/Icon.js